export const updateCreativeId = ({ isPreVinFlow, isMatchingVIN, trackingParent }) => {
  if (isPreVinFlow) {
    return `${trackingParent}_previn`;
  }

  return isMatchingVIN ? trackingParent : `${trackingParent}_novin`;
};
